import React, {useEffect} from 'react'
import {ListDealCard} from "./ListDealCard";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {ListDealMobileCard} from "./ListDealMobileCard";
import CustomInfiniteScroll from "../../components/CustomInfiniteScroll";
import {useShallow} from "zustand/react/shallow";
import {useListDealsStore} from "../../stores/listDealsStore";
import {useDebounce} from "@uidotdev/usehooks";
import {useModalsStore} from "../../stores/modalsStore";

export const ListDealsList = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const findModalByName = useModalsStore((state) => state.findModalByName)

    const selectedDealId = findModalByName("DealModal")?.props?.id

    const {
        deals,
        current_page,
        has_more,
        fetchListDeals,
        shouldFetchNextDeals,
        search
    } = useListDealsStore(
        useShallow((state) => ({
            deals: state.deals,
            fetchListDeals: state.fetchListDeals,
            shouldFetchNextDeals: state.shouldFetchNextDeals,
            current_page: state.current_page,
            has_more: state.has_more,
            search: state.search
        }))
    )

    const debouncedSearch = useDebounce(search, 300)

    const buildParams = (current_page, search, pricing_id) => {
        let queryParams = new URLSearchParams({})

        if (typeof current_page === 'number' && current_page !== 0) {
            queryParams.append("page", current_page + 1)
        }

        if (search.length) {
            queryParams.append("s", search)
        }

        if (pricing_id) {
            queryParams.append("pricing_id", pricing_id)
        }

        return queryParams
    }


    useEffect(function fetchListDealsFromBackendOnMount(){
        fetchListDeals(buildParams(null, debouncedSearch))
    }, [debouncedSearch])

    return (
        <div className={'ListDealsList'}>
            <CustomInfiniteScroll
                useWindow={isTabletOrMobile}
                initialLoad={false}
                pageStart={0}
                loadMore={(page) => {
                    if (shouldFetchNextDeals()) {
                        fetchListDeals(buildParams(current_page, search))
                    }
                }}
                hasMore={has_more}
                className={'ListDealsList_container'}
            >
                {
                    deals?.map((deal) => {
                        const isSelected = Boolean(selectedDealId === deal.id)

                        // if (isTabletOrMobile) {
                        //     return <ListDealMobileCard
                        //         deal={deal}
                        //         key={deal.id}
                        //         isSelected={isSelected}
                        //     />
                        // }

                        return <ListDealCard
                            deal={deal}
                            key={deal.id}
                            isSelected={isSelected}
                        />
                    })
                }
            </CustomInfiniteScroll>
        </div>
    )
}